"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrue = exports.isEmpty = void 0;

var isEmpty = function isEmpty(val) {
  return val === undefined || val === null || val === '';
};

exports.isEmpty = isEmpty;

var isTrue = function isTrue(val) {
  return val === 1 || val === '1' || val === true || val === 'true';
};

exports.isTrue = isTrue;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9jb25kaXRpb24udHMiXSwibmFtZXMiOlsiaXNFbXB0eSIsInZhbCIsInVuZGVmaW5lZCIsImlzVHJ1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNPLElBQU1BLE9BQU8sR0FBRyxTQUFWQSxPQUFVLENBQUFDLEdBQUc7QUFBQSxTQUFJQSxHQUFHLEtBQUtDLFNBQVIsSUFBcUJELEdBQUcsS0FBSyxJQUE3QixJQUFxQ0EsR0FBRyxLQUFLLEVBQWpEO0FBQUEsQ0FBbkI7Ozs7QUFFQSxJQUFNRSxNQUFNLEdBQUcsU0FBVEEsTUFBUyxDQUFBRixHQUFHO0FBQUEsU0FBSUEsR0FBRyxLQUFLLENBQVIsSUFBYUEsR0FBRyxLQUFLLEdBQXJCLElBQTRCQSxHQUFHLEtBQUssSUFBcEMsSUFBNENBLEdBQUcsS0FBSyxNQUF4RDtBQUFBLENBQWxCIiwic291cmNlc0NvbnRlbnQiOlsiXG5leHBvcnQgY29uc3QgaXNFbXB0eSA9IHZhbCA9PiB2YWwgPT09IHVuZGVmaW5lZCB8fCB2YWwgPT09IG51bGwgfHwgdmFsID09PSAnJztcblxuZXhwb3J0IGNvbnN0IGlzVHJ1ZSA9IHZhbCA9PiB2YWwgPT09IDEgfHwgdmFsID09PSAnMScgfHwgdmFsID09PSB0cnVlIHx8IHZhbCA9PT0gJ3RydWUnO1xuIl19